module.exports = __webpack_public_path__ + "static/media/SuccessNextYearOrderBook.d64e196e.svg";